module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-ps.13ff4e50.png";